import React from "react";

const Copyright = () => {
  return (
    <div id="Copyright">
      <h3 id="one">2. Copyright notice</h3>
      <p>
        <ol type="i">
          <li>
            <b>Copyright (c) [2020] [AUUM PLATFORMS PRIVATE LIMITED]</b>
          </li>
          <li>
            Subject to the express provisions of these terms and conditions:
          </li>
          <ol type="a">
            <li>
              we, together with our licensors, own and control all the copyright
              and other intellectual property rights in our website and the
              material on our website; and
            </li>
            <li>
              all the copyright and other intellectual property rights in our
              website and the material on our website are reserved.
            </li>
          </ol>
        </ol>
      </p>
    </div>
  );
};

export default Copyright;
